<script>
export default {
  render(h) {
    const items = this.$slots.default.map(vnode =>
      h('li', { class: 'ace-button-group__item' }, [vnode])
    );

    const buttonType =
      this.$slots.default[0].componentOptions.propsData.variant === 'image'
        ? 'image-buttons'
        : 'text-buttons';

    return h('ul', { class: `ace-button-group--${buttonType}` }, items);
  },
};
</script>

<style scoped lang="scss">
.ace-button-group {
  $this: &;

  margin-bottom: 0;
  padding: 0;

  display: flex;

  list-style-type: none;

  column-gap: 30px;
  justify-content: center;
  &--text-buttons {
    @extend .ace-button-group;
  }
  &--image-buttons {
    @extend .ace-button-group;
    #{$this}__item {
      flex: 1;
    }
  }
  &__item {
    display: flex;

    justify-content: center;
  }
}
</style>
